module.exports = __webpack_public_path__ + "img/img62.851f702c.gif";